import React from 'react';

import { Snackbar, Alert } from '@mui/material';
import { useAppContext } from '@/context/context';
import { SAFE_AREA_TOP } from '@/layouts/mobileLayoutConstants';

const SnackbarWarper = () => {
  const context = useAppContext();
  const snackbar = context?.snackbar || { message: '', severity: 'info' as const, open: false };
  const setSnackbar = context?.setSnackbar || (() => undefined);

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ message: '', severity: 'info', open: false });
  };

  return (
    <Snackbar
      open={snackbar?.open || false}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
      // Mobile (viewport-fit=cover): keep it below the status bar / notch
      sx={{ top: { xs: `calc(8px + ${SAFE_AREA_TOP})`, sm: '24px' } }}
    >
      <Alert onClose={handleClose} severity={snackbar?.severity || 'info'} sx={{ width: '100%' }}>
        {snackbar?.message || ''}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarWarper;
